<div class="about-content">
  <div id="left-about-div">
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageA" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageB" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageC" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageD" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageE" alt="a pic of me"
    /></mat-card>
  </div>
  <div id="center-about-div">
    <mat-card appearance="outlined">
      <img
        id="profile-image"
        mat-card-image
        [src]="_profileImage"
        alt="a pic of me"
      />
      <mat-card-content>
        <p>👋 Hi, I'm Jake</p>
        <p>👀 I'm interested in Cyber Security</p>
        <p>
          As a skilled developer, I specialize in creating web apps,
          microservices, and RESTful APIs using Node.js, Express.js, and Angular
          with IBM Carbon Design System and Angular Material. With a focus on
          Test-Driven Development, I use Mocha, Chai, Jest, and Supertest to
          create robust unit tests for both front-end and back-end interfaces,
          and write OpenAPI 3 documentation for APIs.
        </p>

        <p>
          I currently work at IBM, where I had the opportunity to work on the
          New York State Excelsior Pass project, the first COVID-19 vaccine
          passport designed for NY State, digital credentialing network
          utilizing SMART Health Cards, decentralized identity, and blockchain
          technology.
        </p>

        <p>
          I am skilled in using Git, Jenkins, Jira, and Travis CI for managing
          the development lifecycle in an Agile environment. I have experience
          with SQL and NoSQL databases, including Postgres and MongoDB, and am
          knowledgeable in using Docker and Kubernetes to manage and deploy
          applications in the cloud. I have worked with various cloud platforms,
          including IBM Cloud and Google Cloud Platform.
        </p>
        <p>
          In addition to my technical skills, I have experience mentoring junior
          developers and identifying bottlenecks in existing processes to help
          build tools and solutions for delivering faster results to clients.
        </p>
        <p>
          <em
            >All opinions and ideas here are never on the behalf of my
            employer.</em
          >
        </p>
      </mat-card-content>
    </mat-card>
  </div>
  <div id="right-about-div">
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageF" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageG" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageH" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageI" alt="a pic of me"
    /></mat-card>
    <mat-card appearance="outlined" class="side-image"
      ><img mat-card-image [src]="_sideImageJ" alt="a pic of me"
    /></mat-card>
  </div>
</div>

<!-- <app-feed [direction]="'H'" [feedLocation]="'about'"></app-feed> -->
